<template>
    <div class="animated fadeIn">
        <b-card no-body>
            <b-card-body>
                <b-row class="justify-content-between">
                    <b-col cols="auto">
                        <h5 class="font-weight-bold">Menu Modifiers</h5>
                        <p>Create new modifier groups for your menus.Visit Menu Editor page to assign modifier groups to food or drink items.</p>
                    </b-col>
                    <b-col cols="auto">
                        <b-button-group class="mb-2">
                            <b-button
                                    :class="modeType === 'Food' ? 'activeBtn' : 'deactiveBtn' "
                                    @click="filterGetRestaurantModifier('Food')"
                            >Food</b-button>
                            <b-button
                                    :class="modeType === 'Drink' ? 'activeBtn' : 'deactiveBtn' "
                                    @click="filterGetRestaurantModifier('Drink')"
                            >Drink</b-button>
                        </b-button-group>
                    </b-col>
                </b-row>
                <b-table
                        hover
                        show-empty
                        stacked="md"
                        head-variant="dark"
                        :empty-text="'No Records'"
                        :empty-filtered-text="'NoRecords'"
                        :items="RestaurantMidifierCategoriesAll"
                        :fields="fields"
                >
                    <template v-slot:cell(ModifierCategory)="row">
                        <span class="cursor-pointer" @click="openEditModalModifireGroup(row.item.ModifierCategoryID,row.item.ModifierCategory)">
                            {{row.item.ModifierCategory}}
                        </span>
                    </template>
                    <template v-slot:cell(Type)="row">
                        <span>Food</span>
                    </template>
                    <template v-slot:cell(AppliesTo)="row">
                        <span>{{modeType}}</span>
                    </template>
                    <template v-slot:cell(IsOptional)="row">
                        <div class="cursor-pointer" @click="openEditModalModifireGroup(row.item.ModifierCategoryID,row.item.ModifierCategory)">
                            <span v-if="row.item.IsOptional === 1">Optional</span>
                            <span v-else>Required</span>
                        </div>
                    </template>
                    <template v-slot:cell(Rule)="row">
                        <div class="cursor-pointer" @click="openEditModalModifireGroup(row.item.ModifierCategoryID,row.item.ModifierCategory)">
                            <span v-if="row.item.ChoiceOption !== 'None'">{{row.item.ChoiceOption + ' ' +  row.item.ChoiceNumber}}</span>
                            <span v-else>{{row.item.ChoiceOption}}</span>
                        </div>
                    </template>
                    <template v-slot:cell(Modifiers)="row">
                        <div v-if="row.item.Modifiers !== null" class="cursor-pointer" @click="editModifierOptionSelectedGroup(row.item.ModifierCategoryID, row.item.ModifierCategory, row.item.IsOptional, row.item.ChoiceOption, row.item.ChoiceNumber)">
                            <span>{{row.item.Modifiers}}</span><font-awesome-icon icon="pencil-alt" class="ml-2 cursor-pointer" style="font-size: 1rem"/>
                        </div>
                    </template>
                    <template v-slot:cell(EditModifierBtn)="row">
                        <font-awesome-icon icon="pencil-alt" @click="openEditModalModifireGroup(row.item.ModifierCategoryID,row.item.ModifierCategory)" class="align-middle cursor-pointer"/>
                    </template>

                    <template v-slot:cell(action)="row">
                        <b-btn size="sm" variant="link" class="link" @click="addModifierToSelectedCategory(row.item.ModifierCategoryID, row.item.ModifierCategory, row.item.IsOptional, row.item.ChoiceOption, row.item.ChoiceNumber)">Add Modifier</b-btn>
                    </template>

                </b-table>
            </b-card-body>
            <b-card-footer class="d-flex flex-row justify-content-between">
                <add-modifier-group
                    @addCategory="addCategory"
                />
            </b-card-footer>
        </b-card>

        <c-modal
                v-model="editModalModifierGroup"
                size="lg"
                cancel-label="Save & Exit"
                centered
                title="Edit Modifier Group"
                :tag="false"
                confirm-label="Add modifier"
                :progressing="false"
                hide-footer
        >
            <edit-modifier-group
                    @closeModifierGroup="closeModifierGroup"
                    :selectedModifierGroup="selectedModifierGroup"
                    :SelectedModifierCategoryName="SelectedModifierCategoryName"
                    @completeEdit="completeEdit"
            />
        </c-modal>

        <c-modal
            v-model="addModifierOptionModal"
            size="lg"
            cancel-label="Save & Exit"
            centered
            title="Add Modifier"
            :tag="false"
            confirm-label="Add modifier"
            :progressing="false"
            hide-footer
        >
            <template>
                <AddModifierOption
                        :newAddedCategory="newAddedCategory"
                        @addModfier="addModfier"
                        @closeModifierOption="closeModifierOption"
                        :selectedModifierName="selectedModifierName"
                        :selectedModifierOptional="selectedModifierOptional"
                        :selectedModifierChoiceOption="selectedModifierChoiceOption"
                        :selectedModifierChoiceNumber="selectedModifierChoiceNumber"
                        :modeType="modeType"
                        :AllowSecondLang="AllowSecondLang"
                />
            </template>
        </c-modal>

        <c-modal
                v-model="editModifierOptionModal"
                size="lg"
                cancel-label="Save & Exit"
                centered
                title="Edit Modifier"
                :tag="false"
                confirm-label="Add modifier"
                :progressing="false"
                hide-footer
        >
            <edit-modifier-option
                    :selectedCategoryID="selectedCategoryID"
                    @changeModifier="changeModifier"
                    @closeModifierOption="closeModifierOption"
                    :selectedModifierName="selectedModifierName"
                    :selectedModifierOptional="selectedModifierOptional"
                    :selectedModifierChoiceOption="selectedModifierChoiceOption"
                    :selectedModifierChoiceNumber="selectedModifierChoiceNumber"
                    :modeType="modeType"
                    :AllowSecondLang="AllowSecondLang"
            />
        </c-modal>


<!--        <b-modal v-model="editModifierOptionModal" size="lg" body-class="m-0 p-0" hide-header centered hide-footer>-->
<!--            <edit-modifier-option-->
<!--                    :selectedCategoryID="selectedCategoryID"-->
<!--                    @changeModifier="changeModifier"-->
<!--                    @closeModifierOption="closeModifierOption"-->
<!--                    :selectedModifierName="selectedModifierName"-->
<!--                    :selectedModifierOptional="selectedModifierOptional"-->
<!--                    :selectedModifierChoiceOption="selectedModifierChoiceOption"-->
<!--                    :selectedModifierChoiceNumber="selectedModifierChoiceNumber"-->
<!--                    :modeType="modeType"-->
<!--                    :AllowSecondLang="AllowSecondLang"-->
<!--            />-->
<!--        </b-modal>-->
    </div>
</template>

<script>
    import AddModifierGroup from "./addModifierGroup";
    import AddModifierOption from "./addModifierOption";
    import EditModifierGroup from "./editModifierGroup";
    import EditModifierOption from "./editModifierOption";
    import config from 'SrcConfig'
    import CModal from "../shared/Cmodal";
    export default {
        name: "menuModifiers",
        components: {CModal, EditModifierOption, EditModifierGroup, AddModifierOption, AddModifierGroup},
        data () {
            return {
                modeType: 'Food',
                fields: [
                    { key: 'ModifierCategory', label: 'Modifier Group Name', sortable: false, class: '' },
                    { key: 'EditModifierBtn', label: '', sortable: false, class: '' },
                    { key: 'AppliesTo', label: 'Applies to', sortable: false, class: '' },
                    { key: 'IsOptional', label: 'Type', sortable: false, class: '' },
                    { key: 'Rule', label: 'Rule', sortable: false, class: '' },
                    { key: 'Modifiers', label: 'Modifier Options', sortable: false, class: '' },
                    { key: 'action', label: '', sortable: false, class: '' },
                ],
                items: [

                ],
                addModifierModal: false,
                editModifierModal: false,
                RestaurantMidifierCategoriesAll: [],
                addModifierOptionModal: false,
                newAddedCategory: null,
                editModalModifierGroup: false,
                selectedModifierGroup: null,
                editModifierOptionModal: false,
                selectedCategoryID: null,
                SelectedModifierCategoryName: null,
                selectedModifierName: null,
                selectedModifierOptional: null,
                selectedModifierChoiceOption: null,
                selectedModifierChoiceNumber: null,
                AllowSecondLang: false
            }
        },
        metaInfo () {
            return {
                title: 'Menu Modifiers'
            }
        },
        watch: {
            '$store.state.selectedRestaurantId': {
                handler: function (newVal) {
                    if (newVal) {
                        this.GetRestaurantCategoryModifier(newVal)
                        let object = {
                            RestaurantID: newVal,
                            // UserID: localStorage.getItem('userID'),
                        }
                        this.GetRestaurantAllowance(object)
                    }
                },
                immediate: true
            }
        },
        mounted() {

        },
        methods: {
            GetRestaurantAllowance (object) {
                // get allowTogo beep
                //When this value is true, a beep will sound after reading the orders api
                return this.$api.getRestaurant.GetRestaurantAllowance(object).then(res => {
                    if (res.success) {
                        let AllowSecondLang = res.results.AllowSecondLang
                        this.AllowSecondLang = AllowSecondLang
                        return res
                    }
                })
            },
            filterGetRestaurantModifier (ModifierType) {
                let data = {
                    // UserID: localStorage.getItem('userID'),
                    RestaurantID: this.$store.state.selectedRestaurantId,
                    CategoryID: -1,
                    ModifierType
                }
                this.modeType = ModifierType
                return this.$api.getRestaurant.GetRestaurantCategoryModifier(data, true).then(res => {
                    if (res.success) {
                        this.RestaurantMidifierCategoriesAll = res.results.RestaurantMidifierCategoriesAll
                        return res.results
                    } else {

                    }
                })
            },
            GetRestaurantCategoryModifier(RestaurantID) {
                //get restaurant modifiers group and render in table
                let data = {
                    // UserID: localStorage.getItem('userID'),
                    RestaurantID,
                    CategoryID: -1,
                    ModifierType: this.modeType
                }
                return this.$api.getRestaurant.GetRestaurantCategoryModifier(data, true).then(res => {
                    if (res.success) {
                        this.RestaurantMidifierCategoriesAll = res.results.RestaurantMidifierCategoriesAll
                        return res.results
                    } else {

                    }
                })
            },
            addNewModifierGroup () {
                // open add modifier group modal
                this.addModifierModal = true
            },
            addCategory(newAddedCategory) {
                //update restaurant modifier groups when new modifier group was added
                this.GetRestaurantCategoryModifier(this.$store.state.selectedRestaurantId).then(res => {
                    this.newAddedCategory = newAddedCategory.id
                    this.selectedModifierName = newAddedCategory.CategoryComment
                    this.selectedModifierOptional = newAddedCategory.IsOptional
                    this.selectedModifierChoiceOption = newAddedCategory.ChoiceOption
                    this.selectedModifierChoiceNumber = newAddedCategory.ChoiceNumber


                    this.addModifierModal = false
                    // then open add modifier option and add this to modifier group
                    this.addModifierOptionModal = true
                })
            },

            completeEdit (data) {
                //update restaurant modifier groups when selected modifier group was edited

                this.GetRestaurantCategoryModifier(this.$store.state.selectedRestaurantId)
                this.editModalModifierGroup = data
            },

            changeModifier () {
                //whem any modifier option was edited , update modifier groups table
                this.GetRestaurantCategoryModifier(this.$store.state.selectedRestaurantId)
            },
            addModifierToSelectedCategory (CategoryID, ModifierName, IsOptional, ChoiceOption, ChoiceNumber) {
                this.newAddedCategory = CategoryID
                this.selectedModifierName = ModifierName
                this.selectedModifierOptional = IsOptional
                this.selectedModifierChoiceOption = ChoiceOption
                this.selectedModifierChoiceNumber = ChoiceNumber
                this.addModifierOptionModal = true
            },
            editModifierOptionSelectedGroup (CategoryID, ModifierName, IsOptional, ChoiceOption, ChoiceNumber) {
                this.selectedCategoryID = CategoryID
                this.selectedModifierName = ModifierName
                this.selectedModifierOptional = IsOptional
                this.selectedModifierChoiceOption = ChoiceOption
                this.selectedModifierChoiceNumber = ChoiceNumber
                this.editModifierOptionModal = true
            },
            closeModifierGroup (data) {
                this.addModifierModal = data
                this.editModalModifierGroup = data
            },
            closeModifierOption(data) {
                this.addModifierOptionModal = data
                this.editModifierOptionModal = data
            },
            addModfier(data) {
                //update modifier groups when new modifier option was added
                this.addModifierOptionModal = false
                this.GetRestaurantCategoryModifier(this.$store.state.selectedRestaurantId)
            },
            openEditModalModifireGroup (ModifierCategoryID, ModifierCategoryName) {
                // open edit category group modal
                let data = {
                    // UserID: localStorage.getItem('userID'),
                    RestaurantID: this.$store.state.selectedRestaurantId,
                    CategoryID: ModifierCategoryID,
                    ModifierType: this.modeType
                }
                this.$api.getRestaurant.GetRestaurantCategoryModifier(data, true).then(res => {
                    if (res.success) {
                        this.selectedModifierGroup = res.results.RestaurantMidifierCategoriesAll[0]
                        this.selectedModifierGroup.ModifierType = this.modeType
                        this.editModalModifierGroup = true
                        this.SelectedModifierCategoryName = ModifierCategoryName
                    }
                })

            },
        }
    }
</script>

<style scoped>
    .goMenuHeaderBtn{
        background: #6f7882 !important;
        color: #fff !important;
    }
    .activeBtn {
        background: #f5c31d !important;
        border-color: #c8ced3 !important;
        font-weight: bold;
    }
    .deactiveBtn {
        background: #fff !important;
        border-color: #c8ced3 !important;
        color: #c8ced3 !important;
        font-weight: bold;
    }
</style>
